import { createStore } from 'vuex';

import app from '@/store/modules/app.js';
import auth from '@/store/modules/auth.js';
import creatorLite from '@/store/modules/creatorLite.js';
import dashboard from '@/store/modules/dashboard.js';
import dynamicSubfields from '@/store/modules/dynamicSubfields.js';
import inAppNotifications from '@/store/modules/inAppNotifications.js';
import invites from '@/store/modules/invites.js';
import magicTool from '@/store/modules/magicTool.js';
import posts from '@/store/modules/posts.js';
import ruleForm from '@/store/modules/ruleForm.js';
import rules from '@/store/modules/rules.js';
import support from '@/store/modules/support.js';

const modules = {
  app,
  auth,
  creatorLite,
  dashboard,
  dynamicSubfields,
  inAppNotifications,
  invites,
  magicTool,
  posts,
  ruleForm,
  rules,
};

if (process.env.VUE_APP_SUPPORT_BUILD == 1) {
  modules.support = support;
}

export const store = createStore({
  modules,
  plugins: [],
});
